import { render, staticRenderFns } from "./ProductAvailabilityModal.vue?vue&type=template&id=53a5844e&scoped=true"
import script from "./ProductAvailabilityModal.vue?vue&type=script&lang=js"
export * from "./ProductAvailabilityModal.vue?vue&type=script&lang=js"
import style0 from "./ProductAvailabilityModal.vue?vue&type=style&index=0&id=53a5844e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a5844e",
  null
  
)

export default component.exports